"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridAPProcessor = exports.GIRDV3SUPPORTMAXABILITY = void 0;
/**
 * @author Zhoukai
 * @date 2022/2/9
 * @time 8:53 下午
 * @fileName GridAPProcessor.ts
 * @Description:
 */
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const GridClassicProcessor_1 = require("../GridTrading/GridClassicProcessor");
exports.GIRDV3SUPPORTMAXABILITY = 1000;
function arithmeticOrderPriceDiff(order) {
    var _a, _b, _c;
    return new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high)
        .sub(new trade_utils_lib_1.SafeDecimal((_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.low))
        .div(new trade_utils_lib_1.SafeDecimal((_c = order.exchangeGridV3Order) === null || _c === void 0 ? void 0 : _c.number).sub(1));
}
/**
 * 按照推荐参数产生的区间，计算投资额
 *
 * @param requestParams
 * @param order
 *
 根据计算出的推荐参数从后台获取调整到这组参数所需要加仓的资金：
 需加仓金额取下面两种算法中算出的更大值。
 情况1：推荐参数价格下限上可以挂单，此时每格买卖量不会变化
 需加仓金额=每格买卖数量*∑新增网格对应的挂单价格
 情况2：推荐参数价格下限因最小成交金额限制无法挂单，此时每格买卖量发生变化
 需加仓金额=1.05*（该组参数对应的最小投资额-（quote持仓+base持仓））
 */
function calcNeedAddPositionForAdvise(requestParams, order) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let bottom = requestParams.bottom;
    let top = requestParams.top;
    let count = requestParams.count;
    let needInvest = new trade_utils_lib_1.SafeDecimal(0);
    if (requestParams.gridType === "arithmetic") {
        needInvest = new trade_utils_lib_1.SafeDecimal(bottom)
            .add(new trade_utils_lib_1.SafeDecimal(top))
            .mul(new trade_utils_lib_1.SafeDecimal(count))
            .div(2)
            .sub(new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high)
            .add(new trade_utils_lib_1.SafeDecimal((_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.low))
            .mul(new trade_utils_lib_1.SafeDecimal((_c = order.exchangeGridV3Order) === null || _c === void 0 ? void 0 : _c.number))
            .div(2))
            .mul(new trade_utils_lib_1.SafeDecimal((_d = order.exchangeGridV3Order) === null || _d === void 0 ? void 0 : _d.amount));
    }
    else if (requestParams.gridType === "geometric") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const singleProfit = (0, react_1.useMemo)(() => {
            var _a, _b, _c;
            const result = (0, trade_utils_lib_1.calcProfitPerGrid)(requestParams.gridType, String((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high), String((_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.low), String((_c = order.exchangeGridV3Order) === null || _c === void 0 ? void 0 : _c.number), requestParams.fee);
            return result !== undefined ? result[0] : 0;
        }, [(_e = order.exchangeGridV3Order) === null || _e === void 0 ? void 0 : _e.high, (_f = order.exchangeGridV3Order) === null || _f === void 0 ? void 0 : _f.low, (_g = order.exchangeGridV3Order) === null || _g === void 0 ? void 0 : _g.number, requestParams]);
        needInvest = new trade_utils_lib_1.SafeDecimal(bottom)
            .mul(new trade_utils_lib_1.SafeDecimal(1)
            .sub(trade_utils_lib_1.SafeDecimal.pow(new trade_utils_lib_1.SafeDecimal(singleProfit).add(1), new trade_utils_lib_1.SafeDecimal(count).sub(new trade_utils_lib_1.SafeDecimal((_h = order.exchangeGridV3Order) === null || _h === void 0 ? void 0 : _h.number))))
            .div(new trade_utils_lib_1.SafeDecimal(1).sub(new trade_utils_lib_1.SafeDecimal(singleProfit).add(1))))
            .mul(new trade_utils_lib_1.SafeDecimal((_j = order.exchangeGridV3Order) === null || _j === void 0 ? void 0 : _j.amount));
    }
    needInvest = trade_utils_lib_1.SafeDecimal.max(needInvest, new trade_utils_lib_1.SafeDecimal(requestParams.minInvest).sub(new trade_utils_lib_1.SafeDecimal(exports.GridAPProcessor.useCalcHoldInvest(order, requestParams.currentPrice))));
    return {
        params: Object.assign(Object.assign({}, requestParams), { invest: trade_utils_lib_1.NumberCommonUtils.toFix(needInvest.add(new trade_utils_lib_1.SafeDecimal(requestParams.invest)), (_k = requestParams.symbol.precision) !== null && _k !== void 0 ? _k : 0) }),
        addQuoteAmount: trade_utils_lib_1.NumberCommonUtils.toFix(needInvest, (_l = requestParams.symbol.precision) !== null && _l !== void 0 ? _l : 0),
    };
}
exports.GridAPProcessor = {
    /**
   *  计算区间卖出价格
   * @param requestParams
   * @param originOrder
   *
   *调整后区间内卖出均价：（以下提及参数均为用户自定义的调整后参数）
    当前价格>=网格上限，卖出均价为当前价格。
   当前价格下，所有对应卖单的均价（当前价格之上的卖单的等差/等比求和）
   等差
   卖出均价≈(网格上限+max(网格下限,当前价))/2
   等比
   N: 卖单数=min(网格数-1, roundup(log(网格上限/当前价,(1+每格网格利润率)),0))
   A1=网格上限
   q=1/(1+每格网格利润率)
   卖出均价=等比数列求和/卖单数=(a1*(1-q^n)/(1-q))/n
   */
    calcUserParamsAvgSellPrice(requestParams, originOrder) {
        let avgSellPrice = new trade_utils_lib_1.SafeDecimal(0);
        if (new trade_utils_lib_1.SafeDecimal(requestParams.currentPrice).greaterThanOrEqualTo(requestParams.top)) {
            avgSellPrice = new trade_utils_lib_1.SafeDecimal(requestParams.currentPrice);
        }
        else {
            if (requestParams.gridType === "arithmetic") {
                // 等差
                avgSellPrice = new trade_utils_lib_1.SafeDecimal(requestParams.top)
                    .add(trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(requestParams.bottom), new trade_utils_lib_1.SafeDecimal(requestParams.currentPrice)))
                    .div(2);
            }
            else {
                const result = (0, trade_utils_lib_1.calcProfitPerGrid)(requestParams.gridType, String(requestParams.top), String(requestParams.bottom), String(requestParams.count), requestParams.fee);
                const singleProfit = result !== undefined ? result[0] : 0;
                let sellCount = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(requestParams.count).sub(1), trade_utils_lib_1.SafeDecimal.log(new trade_utils_lib_1.SafeDecimal(requestParams.top).div(new trade_utils_lib_1.SafeDecimal(requestParams.currentPrice)), new trade_utils_lib_1.SafeDecimal(singleProfit).add(1)).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP));
                let q = new trade_utils_lib_1.SafeDecimal(1).div(new trade_utils_lib_1.SafeDecimal(singleProfit).add(1));
                avgSellPrice = new trade_utils_lib_1.SafeDecimal(requestParams.top)
                    .mul(new trade_utils_lib_1.SafeDecimal(1).sub(trade_utils_lib_1.SafeDecimal.pow(q, sellCount)).div(new trade_utils_lib_1.SafeDecimal(1).sub(q)))
                    .div(sellCount);
            }
        }
        return avgSellPrice;
    },
    /**
     * 计算调整后区间卖出均价低于买入成本
     * @param requestParams
     * @param originOrder
     */
    sellPriceLessThanCost(requestParams, originOrder) {
        var _a;
        // 持仓买入成本 > 卖出均价
        return new trade_utils_lib_1.SafeDecimal((_a = originOrder.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.avgOpenPrice).greaterThan(exports.GridAPProcessor.calcUserParamsAvgSellPrice(requestParams, originOrder));
    },
    /**
     * 计算是否需要认亏
     * @param requestParams
     * @param originOrder
     */
    calcAcceptLosses(requestParams, originOrder) {
        var _a, _b;
        const requestParamsNeedCoin = GridClassicProcessor_1.GridClassicProcessor.calculateOpenPositionCoinValue(requestParams);
        // 调整参数需要卖出base
        const conditionA_1 = new trade_utils_lib_1.SafeDecimal(requestParamsNeedCoin === null || requestParamsNeedCoin === void 0 ? void 0 : requestParamsNeedCoin.needBase).lessThan(new trade_utils_lib_1.SafeDecimal((_a = originOrder.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.baseAmount));
        // 持仓买入成本 > 当前价格
        const conditionA_2 = new trade_utils_lib_1.SafeDecimal((_b = originOrder.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.avgOpenPrice).greaterThan(new trade_utils_lib_1.SafeDecimal(requestParams.currentPrice));
        // 需要认亏
        return conditionA_1 && conditionA_2;
    },
    /**
   * 计算是否需要推荐参数
   * @param requestParams
   * @param originOrder
   *
   *
   * 有推荐参数
   当用户调整后的参数满足以下条件时展示此页面：
   1.需要认亏 (调整参数需要卖出base &&持仓买入成本>当前价格)或者调整后区间内卖出均价低于买入成本

   2.价格下限下移 （调整前的价格下限>调整后的价格下限）

   无推荐参数
   当用户调整后的参数满足以下条件时展示此页面：
   需要认亏
   调整参数需要卖出base
   持仓买入成本>当前价格
   无法推荐
   价格下限不动或上移了
   调整前的价格下限<=调整后的价格下限
   调整前的网格数为1000格
   * @param requestParams
   * @param originOrder

   */
    calcAdviseParamExist(requestParams, originOrder) {
        var _a, _b;
        // 需要认亏
        const conditionA = exports.GridAPProcessor.calcAcceptLosses(requestParams, originOrder);
        //价格下限下移
        const conditionB_1 = new trade_utils_lib_1.SafeDecimal(requestParams.bottom).lessThan(new trade_utils_lib_1.SafeDecimal((_a = originOrder.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.low));
        const conditionB_2 = ((_b = originOrder.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.number) !== exports.GIRDV3SUPPORTMAXABILITY;
        // 有调整空间
        const conditionB = conditionB_1 && conditionB_2;
        //调整后区间卖出均价低于买入成本
        const conditionC = exports.GridAPProcessor.sellPriceLessThanCost(requestParams, originOrder);
        return conditionB && (conditionA || conditionC);
    },
    /**
     * 计算当前持仓价值
     * quote持仓+base持仓
     * @param order
     * @param price
     */
    useCalcHoldInvest(order, price) {
        var _a, _b;
        return (0, react_1.useMemo)(() => {
            var _a, _b;
            return new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.baseAmount)
                .mul(new trade_utils_lib_1.SafeDecimal(price))
                .add(new trade_utils_lib_1.SafeDecimal((_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.quoteAmount))
                .toString();
        }, [(_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.baseAmount, (_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.quoteAmount, price]);
    },
    /**
   * 推荐参数
   * @param requestParams 用户自定义参数
   * @param order
   * @param tradeApi
   *
   价格上限：调整前价格上限
   每格買賣數量：同调整前每格买卖数量
   网格数=调整前网格数+roundup((调整前网格下线-用户自定义调整后网格下限)/网格间价格差,0)
   价格下限=价格上限-(网格数-1)*网格间价格差
   等比
   价格上限：调整前价格上限
   每格買賣數量：同调整前每格买卖数量
   网格数=roundup(log(调整前价格上限/用户自定义调整后网格下限,(1+每格网格利润率)),0)+1
   价格下限=价格上限/(1+每格网格利润率)^(网格数-1)

   推荐参数中，最多允许用户将网格数增加到1000格。
   如果计算出来的网格数大于1000格，则推荐参数中的网格数目只取1000格。
   按照1000格去计算价格下限以及需要加仓的金额。
   */
    useCalcAdviseParam(requestParams, order, tradeApi) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const market = (_a = order.exchange) !== null && _a !== void 0 ? _a : TradeAPILib_1.ExchangeID.PIONEXV2;
        if (order.exchangeGridV3Order === undefined) {
            return { params: requestParams, addQuoteAmount: "0" };
        }
        if (requestParams.gridType === "arithmetic") {
            // 等差
            const originRow = (_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.number;
            const priceDifference = arithmeticOrderPriceDiff(order);
            let gridRow = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(originRow).add(new trade_utils_lib_1.SafeDecimal((_c = order.exchangeGridV3Order) === null || _c === void 0 ? void 0 : _c.low)
                .sub(new trade_utils_lib_1.SafeDecimal(requestParams.bottom))
                .div(new trade_utils_lib_1.SafeDecimal(priceDifference))
                .toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP)), exports.GIRDV3SUPPORTMAXABILITY);
            // eslint-disable-next-line react-hooks/rules-of-hooks
            let gridBottomPrice = (0, react_1.useMemo)(() => {
                var _a, _b;
                return new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high)
                    .sub(new trade_utils_lib_1.SafeDecimal(gridRow).sub(1).mul(priceDifference))
                    .toDecimalPlaces((_b = requestParams.symbol.precision) !== null && _b !== void 0 ? _b : 8);
            }, [gridRow, (_d = order.exchangeGridV3Order) === null || _d === void 0 ? void 0 : _d.high, priceDifference, requestParams.symbol.precision]);
            if (gridBottomPrice.lessThanOrEqualTo(0)) {
                gridBottomPrice = gridBottomPrice.add(priceDifference);
                gridRow = gridRow.sub(1);
            }
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const result = GridClassicProcessor_1.GridClassicProcessor.useUserParams(order.quote, order.quote, (_e = order.exchangeGridV3Order) === null || _e === void 0 ? void 0 : _e.trend, (_f = order.exchangeGridV3Order) === null || _f === void 0 ? void 0 : _f.high.toString(), gridBottomPrice.toString(), gridRow.toString(), requestParams.invest, 0, (_g = order.exchangeGridV3Order) === null || _g === void 0 ? void 0 : _g.gridType, exports.GIRDV3SUPPORTMAXABILITY, requestParams.baseAvailable, requestParams.quoteAvailable, false, "", "", "", requestParams.currentPrice, requestParams.symbol, market, tradeApi, order.orderType, "text", "", requestParams.takeProfitDelay, requestParams.stopLostDelay);
            return calcNeedAddPositionForAdvise(result, order);
        }
        else if (requestParams.gridType === "geometric") {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const singleProfit = (0, react_1.useMemo)(() => {
                var _a, _b, _c;
                const result = (0, trade_utils_lib_1.calcProfitPerGrid)(requestParams.gridType, String((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high), String((_b = order.exchangeGridV3Order) === null || _b === void 0 ? void 0 : _b.low), String((_c = order.exchangeGridV3Order) === null || _c === void 0 ? void 0 : _c.number), requestParams.fee);
                return result !== undefined ? result[0] : 0;
            }, [(_h = order.exchangeGridV3Order) === null || _h === void 0 ? void 0 : _h.high, (_j = order.exchangeGridV3Order) === null || _j === void 0 ? void 0 : _j.low, (_k = order.exchangeGridV3Order) === null || _k === void 0 ? void 0 : _k.number, requestParams]);
            // eslint-disable-next-line react-hooks/rules-of-hooks
            let gridRow = (0, react_1.useMemo)(() => {
                var _a;
                return trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(trade_utils_lib_1.SafeDecimal.log(new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high).div(new trade_utils_lib_1.SafeDecimal(requestParams.bottom)), new trade_utils_lib_1.SafeDecimal(singleProfit).add(1)))
                    .toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP)
                    .add(1), exports.GIRDV3SUPPORTMAXABILITY);
            }, [(_l = order.exchangeGridV3Order) === null || _l === void 0 ? void 0 : _l.high, requestParams.bottom, singleProfit]);
            // eslint-disable-next-line react-hooks/rules-of-hooks
            let gridBottomPrice = (0, react_1.useMemo)(() => {
                var _a, _b;
                return new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.high)
                    .div(trade_utils_lib_1.SafeDecimal.pow(new trade_utils_lib_1.SafeDecimal(singleProfit).add(1), gridRow.sub(1)))
                    .toDecimalPlaces((_b = requestParams.symbol.precision) !== null && _b !== void 0 ? _b : 8);
            }, [gridRow, (_m = order.exchangeGridV3Order) === null || _m === void 0 ? void 0 : _m.high, requestParams.symbol.precision, singleProfit]);
            if (gridBottomPrice.lessThanOrEqualTo(0)) {
                gridBottomPrice = gridBottomPrice.add(new trade_utils_lib_1.SafeDecimal(gridBottomPrice).mul(new trade_utils_lib_1.SafeDecimal(singleProfit).add(1)));
                gridRow = gridRow.sub(1);
            }
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const result = GridClassicProcessor_1.GridClassicProcessor.useUserParams(order.quote, order.quote, (_o = order.exchangeGridV3Order) === null || _o === void 0 ? void 0 : _o.trend, (_p = order.exchangeGridV3Order) === null || _p === void 0 ? void 0 : _p.high.toString(), gridBottomPrice.toString(), gridRow.toString(), requestParams.invest, 0, (_q = order.exchangeGridV3Order) === null || _q === void 0 ? void 0 : _q.gridType, exports.GIRDV3SUPPORTMAXABILITY, requestParams.baseAvailable, requestParams.quoteAvailable, false, "", "", "", requestParams.currentPrice, requestParams.symbol, market, tradeApi, order.orderType, "text", "", requestParams.takeProfitDelay, requestParams.stopLostDelay);
            return calcNeedAddPositionForAdvise(result, order);
        }
        return { params: requestParams, addQuoteAmount: "0" };
    },
    /**
     *预计盈亏=止盈时统一卖出base盈亏+运行期间分批卖出base盈亏
     运行期间卖出盈亏=运行期间卖出base数量*(运行期间成交均价-平均持仓成本)
     止盈时统一卖出盈亏=（当前base持仓-运行期间卖出base数量）*（止盈价格-平均持仓成本）
     运行期间卖出base数量&运行期间成交均价
     初始假设当前价格之下的买单不挂单。如果计算出的待卖出base数量比实际持有base数量大，意味着空卖单，运行期间成交卖单数-1。
     等差
     网格间距=(网格上限-网格下限)/(网格数-1)
     初始假设下的运行期间成交卖单数
     =总挂单数-止盈价格之上的挂单数-当前价格之下的挂单数
     =(网格数-1)-roundup((网格上限-min(止盈价格，网格上限))/网格间距,0)-max(0,roundup((max(当前价格，网格下线)-网格下线)/网格间距,0)-1)
     初始假设下的运行期间卖出base数量
     =初始假设下的运行期间成交卖单数*每格买卖数量
     如果运行期间卖出base数量<base持仓，意味着空买单假设成立。
     运行期间卖出数量=初始假设下的运行期间卖出base数量
     如果运行期间卖出base数量>=base持仓，意味着应该空一个卖单，此时：
     运行期间成交格数=初始假设下的运行期间成交卖单数
     运行期间成交数量=运行期间成交卖单数*每格买卖数量
     两种情况下成交均价算法一样，成交均价算法：
     成交网格中价格最高的网格
     =价格上限-网格间距*止盈价格之上的挂单数
     成交网格中价格最低的网格
     =价格上限-网格间距*（止盈价格之上的挂单数+(运行期间成交卖单数-1)）
     均价=½*(价格最低的网格+价格最高的网格)
     等比
     初始假设下的运行期间成交卖单数
     =总挂单数-止盈价格之上的挂单数-当前价格之下的挂单数
     =(网格数-1)-roundup(log(网格上限/min(止盈价格,网格上限),(1+每格网格利润率)),0)-max(0,roundup(log(max(当前价,网格下限)/网格上限,(1+每格网格利润率)),0)-1)
     初始假设下的运行期间卖出base数量
     =初始假设下的运行期间成交卖单数*每格买卖数量
     如果运行期间卖出base数量<base持仓，意味着空买单假设成立。
     运行期间卖出数量=初始假设下的运行期间卖出base数量
     如果运行期间卖出base数量>=base持仓，意味着应该空一个卖单，此时：
     运行期间成交格数=初始假设下的运行期间成交卖单数
     运行期间成交数量=运行期间成交卖单数*每格买卖数量
     成交均价
     n: 运行期间成交卖单数
     q=1/(1+每格网格利润率)
     a1：成交网格中价格最高的网格
     =网格上限*q^止盈价格之上的挂单数
     =网格上限*q^roundup(log(网格上限/min(止盈价格,网格上限),(1+每格网格利润率)),0)
     卖出均价=等比数列求和/卖单数=(a1*(1-q^n)/(1-q))/n

     *
     * 计算止盈预计盈亏
     * @param order
     * @param averageCost 平均持仓成本
     * @param _ProfitStopPrice
     * @param _currentPrice
     * @param singleProfit
     */
    calcGridProfitStopPNL(order, averageCost, _ProfitStopPrice, _currentPrice, singleProfit) {
        const gridV3Order = order.exchangeGridV3Order;
        if (gridV3Order === undefined) {
            return 0;
        }
        const highPrice = new trade_utils_lib_1.SafeDecimal(gridV3Order.high);
        const lowPrice = new trade_utils_lib_1.SafeDecimal(gridV3Order.low);
        const profitStopPrice = new trade_utils_lib_1.SafeDecimal(_ProfitStopPrice);
        const currentPrice = new trade_utils_lib_1.SafeDecimal(_currentPrice);
        if (gridV3Order.gridType === TradeAPILib_1.GRID_TYPE.arithmetic) {
            //等差'
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const priceRange = arithmeticOrderPriceDiff(order);
            //止盈价格之上的挂单数;
            const sellC_1 = highPrice
                .sub(trade_utils_lib_1.SafeDecimal.min(profitStopPrice, highPrice))
                .div(priceRange)
                .toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP);
            //当前价格之下的挂单数
            const sellC_2 = trade_utils_lib_1.SafeDecimal.max(0, trade_utils_lib_1.SafeDecimal.max(currentPrice, lowPrice).sub(lowPrice).div(priceRange).sub(1).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP));
            //运行期间卖单数
            let sellC = trade_utils_lib_1.SafeDecimal.max(0, new trade_utils_lib_1.SafeDecimal(gridV3Order.number).sub(1).sub(sellC_1).sub(sellC_2));
            //运行期间卖出base数量
            let sellA = sellC.mul(new trade_utils_lib_1.SafeDecimal(gridV3Order.amount));
            if (sellA.greaterThan(new trade_utils_lib_1.SafeDecimal(gridV3Order.baseAmount))) {
                sellC = trade_utils_lib_1.SafeDecimal.max(sellC.sub(1), 0);
                sellA = sellC.mul(new trade_utils_lib_1.SafeDecimal(gridV3Order.amount));
            }
            //成交网格中价格最高的网格
            const sellP_1 = highPrice.sub(sellC_1.mul(priceRange));
            //成交网格中价格最低的网格
            const sellP_2 = highPrice.sub(sellC_1.add(sellC.sub(1)).mul(priceRange));
            //运行期间卖出均价
            const sellP = sellP_1.add(sellP_2).div(2);
            //运行期间卖出盈亏
            const sellPNL = sellA.mul(sellP.sub(averageCost));
            //止盈时刻统一卖出盈亏
            const endPNL = new trade_utils_lib_1.SafeDecimal(gridV3Order.baseAmount).sub(sellA).mul(profitStopPrice.sub(averageCost));
            return sellPNL.add(endPNL).toNumber();
        }
        else if (gridV3Order.gridType === TradeAPILib_1.GRID_TYPE.geometric) {
            //等比
            //等比系数；
            const q = new trade_utils_lib_1.SafeDecimal(singleProfit).add(1);
            //止盈价格之上的挂单数;
            const sellC_1 = trade_utils_lib_1.SafeDecimal.max(0, trade_utils_lib_1.SafeDecimal.log(highPrice.div(trade_utils_lib_1.SafeDecimal.min(highPrice, profitStopPrice)), q).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP));
            //当前价格之下的挂单数
            const sellC_2 = trade_utils_lib_1.SafeDecimal.max(trade_utils_lib_1.SafeDecimal.log(trade_utils_lib_1.SafeDecimal.max(currentPrice, lowPrice).div(lowPrice), q).sub(1).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP), 0);
            //运行期间卖单数
            let sellC = trade_utils_lib_1.SafeDecimal.max(0, new trade_utils_lib_1.SafeDecimal(gridV3Order.number).sub(1).sub(sellC_1).sub(sellC_2));
            //运行期间卖出base数量
            let sellA = sellC.mul(new trade_utils_lib_1.SafeDecimal(gridV3Order.amount));
            if (sellA.greaterThan(new trade_utils_lib_1.SafeDecimal(gridV3Order.baseAmount))) {
                sellC = trade_utils_lib_1.SafeDecimal.max(sellC.sub(1), 0);
                sellA = sellC.mul(new trade_utils_lib_1.SafeDecimal(gridV3Order.amount));
            }
            const q1 = new trade_utils_lib_1.SafeDecimal(1).div(q);
            //运行期间卖出均价
            const sellP = sellC.equals(0)
                ? new trade_utils_lib_1.SafeDecimal(0)
                : highPrice
                    .mul(trade_utils_lib_1.SafeDecimal.pow(q1, sellC_1))
                    .mul(new trade_utils_lib_1.SafeDecimal(1).sub(trade_utils_lib_1.SafeDecimal.pow(q1, sellC)))
                    .div(new trade_utils_lib_1.SafeDecimal(1).sub(q1))
                    .div(sellC);
            //运行期间卖出盈亏
            const sellPNL = sellA.mul(sellP.sub(averageCost));
            //止盈时刻统一卖出盈亏
            const endPNL = new trade_utils_lib_1.SafeDecimal(gridV3Order.baseAmount).sub(sellA).mul(profitStopPrice.sub(averageCost));
            return sellPNL.add(endPNL).toNumber();
        }
        return 0;
    },
    /**
     * 预计盈亏=当前持仓盈亏+后续买入持仓盈亏
     当前持仓盈亏：
     当前持仓盈亏=当前base持仓数量*（止损价格-平均持仓成本）
     后续买入持仓盈亏：（此项均为估算）
     后续买入持仓盈亏=预期买入base数量*（止损价格-预期买入base均价）
     等差
     止损时成交的网格数
     =总挂单数-当前价格之上的挂单数-止损价格之下的挂单数
     =(网格数-1)-roundup((网格上限-min(当前价格，网格上限))/网格间距,0)-roundup((max(止损价格，网格下线)-网格下线)/网格间距,0)
     预期买入base数量
     =止损时成交的网格数*每格买卖数量
     成交均价:
     成交网格中价格最高的网格
     =价格上限-网格间距*（当前价格之上的挂单数+1）
     成交网格中价格最低的网格
     =价格上限-网格间距*（（当前价格之上的挂单数+1）+(运行期间成交卖单数-1)）
     均价=½*(价格最低的网格+价格最高的网格)
     等比
     止损时成交的买单数
     =总挂单数-当前价格之上的挂单数-止损价格之下的挂单数
     =(网格数-1)-roundup(log(网格上限/min(当前价格,网格上限),(1+每格网格利润率)),0)-roundup(log(max(止损价格,网格下限)/网格上限,(1+每格网格利润率)),0)
     预期买入base数量
     预期买入base数量
     =止损时成交的网格数*每格买卖数量
     预期买入base均价
     n: 运行期间成交卖单数
     q=1/(1+每格网格利润率)
     a1：成交网格中价格最高的网格
     =网格上限*q^（当前价格之上的挂单数+1)
     =网格上限*q^(roundup(log(网格上限/min(当前价格,网格上限),(1+每格网格利润率)),0)+1)
     卖出均价=等比数列求和/卖单数=(a1*(1-q^n)/(1-q))/n

     *
     * 计算止损预计盈亏
     * @param order
     * @param averageCost
     * @param _lossStopPrice
     * @param _currentPrice
     * @param singleProfit
     */
    calcGridLossStopPNL(order, averageCost, _lossStopPrice, _currentPrice, singleProfit) {
        const gridV3Order = order.exchangeGridV3Order;
        if (gridV3Order === undefined) {
            return 0;
        }
        const highPrice = new trade_utils_lib_1.SafeDecimal(gridV3Order.high);
        const lowPrice = new trade_utils_lib_1.SafeDecimal(gridV3Order.low);
        const lossStopPrice = new trade_utils_lib_1.SafeDecimal(_lossStopPrice);
        const currentPrice = new trade_utils_lib_1.SafeDecimal(_currentPrice);
        if (gridV3Order.gridType === TradeAPILib_1.GRID_TYPE.arithmetic) {
            //等差'
            const priceRange = arithmeticOrderPriceDiff(order);
            //当前价格之上的挂单数;
            const buyC_1 = trade_utils_lib_1.SafeDecimal.max(0, highPrice.sub(trade_utils_lib_1.SafeDecimal.min(currentPrice, highPrice)).div(priceRange).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP));
            //止损价格之下的挂单数
            const buyC_2 = trade_utils_lib_1.SafeDecimal.max(0, trade_utils_lib_1.SafeDecimal.max(lossStopPrice, lowPrice).sub(lowPrice).div(priceRange).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP));
            //止损是买单数
            const buyC = trade_utils_lib_1.SafeDecimal.max(0, new trade_utils_lib_1.SafeDecimal(gridV3Order.number).sub(1).sub(buyC_1).sub(buyC_2));
            //运行期间买入base数量
            const buyA = buyC.mul(new trade_utils_lib_1.SafeDecimal(gridV3Order.amount));
            //成交网格中价格最高的网格
            const buyP_1 = highPrice.sub(buyC_1.add(1).mul(priceRange));
            //成交网格中价格最低的网格
            const buyP_2 = highPrice.sub(buyC_1
                .add(1)
                .add(trade_utils_lib_1.SafeDecimal.max(buyC.sub(1), 0))
                .mul(priceRange));
            //运行期间买入均价
            const buyP = buyP_1.add(buyP_2).div(2);
            //后续买入盈亏
            const buyPNL = buyA.mul(lossStopPrice.sub(buyP));
            //当前持仓盈亏
            const endPNL = new trade_utils_lib_1.SafeDecimal(gridV3Order.baseAmount).mul(lossStopPrice.sub(averageCost));
            return buyPNL.add(endPNL).toNumber();
        }
        else if (gridV3Order.gridType === TradeAPILib_1.GRID_TYPE.geometric) {
            //等比
            //等比系数；
            const q = new trade_utils_lib_1.SafeDecimal(singleProfit).add(1);
            //当前价格之上的挂单数;
            const buyC_1 = trade_utils_lib_1.SafeDecimal.max(0, trade_utils_lib_1.SafeDecimal.log(highPrice.div(trade_utils_lib_1.SafeDecimal.min(currentPrice, highPrice)), q).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP));
            //止损价格之下的挂单数
            const buyC_2 = trade_utils_lib_1.SafeDecimal.max(trade_utils_lib_1.SafeDecimal.log(trade_utils_lib_1.SafeDecimal.max(lossStopPrice, lowPrice).div(lowPrice), q).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_UP), 0);
            //运行期间买单数
            const buyC = trade_utils_lib_1.SafeDecimal.max(0, new trade_utils_lib_1.SafeDecimal(gridV3Order.number).sub(1).sub(buyC_1).sub(buyC_2));
            //运行期间买入base数量
            const buyA = buyC.mul(new trade_utils_lib_1.SafeDecimal(gridV3Order.amount));
            const q1 = new trade_utils_lib_1.SafeDecimal(1).div(q);
            //运行期间买入均价
            const buyP = buyC.equals(0)
                ? new trade_utils_lib_1.SafeDecimal(0)
                : highPrice
                    .mul(trade_utils_lib_1.SafeDecimal.pow(q1, buyC_1.add(1)))
                    .mul(new trade_utils_lib_1.SafeDecimal(1).sub(trade_utils_lib_1.SafeDecimal.pow(q1, buyC)))
                    .div(new trade_utils_lib_1.SafeDecimal(1).sub(q1))
                    .div(buyC);
            //后续买入盈亏
            const buyPNL = buyA.mul(lossStopPrice.sub(buyP));
            //当前持仓盈亏
            const endPNL = new trade_utils_lib_1.SafeDecimal(gridV3Order.baseAmount).mul(lossStopPrice.sub(averageCost));
            return buyPNL.add(endPNL).toNumber();
        }
        return 0;
    },
};
